<h2>Crear Orden</h2>

<div class="card">
  <p-stepper [(value)]="activeStep" [linear]="true">
    <p-step-list>
      <p-step [value]="1">Información</p-step>
      <p-step [value]="2">Selección</p-step>
      <p-step [value]="3">Resumen</p-step>
      <p-step [value]="4">Confirmación</p-step>
    </p-step-list>

    <p-step-panels>

      <!-- Paso 1: Información -->
      <p-step-panel [value]="1">
        <ng-template pTemplate="content">
          <form [formGroup]="infoForm" class="formgrid grid surface-card shadow-2 border-round p-4 mt-3">

            <div class="field col-12 md:col-4">
              <label for="accountId" class="block font-bold mb-2">Cuenta <span class="req">*</span></label>
              <p-select id="accountId" formControlName="accountId" [options]="accounts" optionLabel="name"
                optionValue="accountId" [filter]="true" filterBy="name" [showClear]="true"
                [loading]="accountLoading" (onFilter)="loadAccounts($event)" placeholder="Selecciona una cuenta"
                [fluid]="true" [appendTo]="'body'"></p-select>
            </div>

            <div class="field col-12 md:col-4">
              <label class="block font-bold mb-2">Tipo de orden <span class="req">*</span></label>
              <p-selectButton formControlName="orderType" [options]="orderTypeOptions" optionLabel="label"
                optionValue="value" [fluid]="true"></p-selectButton>
            </div>

            <div class="field col-12 md:col-4">
              <label for="scheduledDate" class="block font-bold mb-2">Fecha y hora programada <span class="req">*</span></label>
              <p-datepicker id="scheduledDate" formControlName="scheduledDate" [showTime]="true" [hourFormat]="'12'"
                [minDate]="minDate" [showIcon]="true" iconDisplay="input" [fluid]="true"
                [appendTo]="'body'"></p-datepicker>
            </div>

            <div class="field col-12 md:col-4">
              <label for="titular" class="block font-bold mb-2">Titular de la orden</label>
              <input pInputText id="titular" formControlName="titular" class="w-full"
                placeholder="Nombre de quien atiende/entrega">
            </div>

            <div class="field col-12 md:col-4">
              <label class="block font-bold mb-2">Ubicación <span class="req">*</span></label>
              <p-selectButton formControlName="location" [options]="locationOptions" optionLabel="label"
                optionValue="value" [fluid]="true"></p-selectButton>
            </div>

            <div class="field col-12 md:col-4">
              <label for="platform" class="block font-bold mb-2">Plataforma <span class="req">*</span></label>
              <p-select id="platform" formControlName="platform" [options]="platformOptions" [filter]="true"
                placeholder="Selecciona la plataforma" [fluid]="true" [appendTo]="'body'"></p-select>
            </div>

            @if (infoForm.get('location')?.value === 'DOMICILIO') {
              <div class="field col-12">
                <label for="address" class="block font-bold mb-2">Dirección <span class="req">*</span></label>
                <textarea pTextarea id="address" formControlName="address" rows="2" class="w-full"
                  placeholder="Calle, número, colonia, ciudad"></textarea>
              </div>
            }

            <div class="field col-12">
              <label for="description" class="block font-bold mb-2">Descripción</label>
              <textarea pTextarea id="description" formControlName="description" rows="2" class="w-full"
                placeholder="Notas generales de la orden"></textarea>
            </div>
          </form>

          <div class="flex justify-content-between pt-4">
            <button pButton label="Cancelar" icon="pi pi-times" severity="secondary" [outlined]="true"
              class="footer-btn" (click)="cancelOrderCreation()"></button>
            <button pButton label="Siguiente" icon="pi pi-arrow-right" iconPos="right" class="footer-btn"
              (click)="goToStep(2)"></button>
          </div>
        </ng-template>
      </p-step-panel>

      <!-- Paso 2: Selección -->
      <p-step-panel [value]="2">
        <ng-template pTemplate="content">

          @if (stockWarningMessage) {
            <p-message severity="warn" styleClass="w-full mb-3">{{ stockWarningMessage }}</p-message>
          }
          @if (canCreateEmptyOrder && selectedItems.length === 0) {
            <p-message severity="info" styleClass="w-full mb-3">
              Puedes continuar sin productos y agregarlos después editando la orden, una vez que lleguen a bodega.
            </p-message>
          }

          <div class="grid">
            <div class="col-12 lg:col-6">
              <div class="wizard-panel h-full">
                <h4 class="mt-0"><span class="panel-icon"><i class="pi pi-th-large"></i></span>Catálogo — {{ selectedAccountName }}</h4>
                <input pInputText class="w-full mb-3" placeholder="Buscar por SKU, Descripción o UPC"
                  [ngModel]="catalogSearchTerm" (ngModelChange)="onCatalogSearch($event)">
                <p-table [value]="catalogProducts" dataKey="productId" [lazy]="true"
                  (onLazyLoad)="loadCatalogProducts($event)" [paginator]="true" [rows]="catalogRows"
                  [totalRecords]="catalogTotalRecords" [loading]="catalogLoading"
                  styleClass="p-datatable-sm p-datatable-gridlines">
                  <ng-template pTemplate="header">
                    <tr>
                      <th>SKU</th>
                      <th>Descripción</th>
                      <th>Variante</th>
                      <th>En Stock</th>
                      <th></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-product>
                    <tr>
                      <td>{{ product.sku }}</td>
                      <td>{{ product.description }}</td>
                      <td>{{ product.variant }}</td>
                      <td>{{ product.availableQuantity }}</td>
                      <td>
                        <button pButton icon="pi pi-plus" class="p-button-rounded p-button-sm"
                          pTooltip="Agregar" [disabled]="!canAddToCart(product)"
                          (click)="addToCart(product)"></button>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="5" class="text-center p-3">
                        @if (!selectedAccountName) {
                          Selecciona una cuenta en el Paso 1.
                        } @else {
                          No se encontraron productos.
                        }
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>

            <div class="col-12 lg:col-6">
              <div class="wizard-panel h-full">
                <h4 class="mt-0 flex align-items-center gap-2 flex-wrap">
                  <span class="panel-icon"><i class="pi pi-shopping-cart"></i></span>
                  <span>Productos seleccionados ({{ selectedItems.length }})</span>
                  <p-tag [value]="'Total: ' + totalSelectedQuantity + ' artículos'" severity="info"></p-tag>
                </h4>
                <p-table [value]="selectedItems" dataKey="productId" styleClass="p-datatable-sm p-datatable-gridlines">
                  <ng-template pTemplate="header">
                    <tr>
                      <th>#</th>
                      <th>SKU</th>
                      <th>Descripción</th>
                      <th>Variante</th>
                      <th>En Stock</th>
                      <th>Cantidad</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                    <tr [class.insufficient-row]="item.insufficientStock">
                      <td>{{ rowIndex + 1 }}</td>
                      <td>{{ item.sku }}</td>
                      <td>{{ item.description }}</td>
                      <td>{{ item.variant }}</td>
                      <td>{{ item.availableQuantity }}</td>
                      <td>
                        <p-inputNumber [(ngModel)]="item.quantity" [min]="1"
                          [max]="isEntrega ? item.availableQuantity : undefined" [invalid]="item.insufficientStock"
                          (ngModelChange)="item.insufficientStock = false" inputStyleClass="w-full" [showButtons]="true">
                        </p-inputNumber>
                        @if (item.insufficientStock) {
                          <small class="p-error block">Solo hay {{ item.availableQuantity }} disponibles</small>
                        }
                      </td>
                      <td>
                        <button pButton icon="pi pi-comment" class="p-button-rounded p-button-text"
                          [severity]="item.comments ? 'info' : 'secondary'" pTooltip="Notas"
                          (click)="openCommentPopover($event, item, commentPopover)"></button>
                      </td>
                      <td>
                        <button pButton icon="pi pi-trash" severity="danger" class="p-button-rounded p-button-text"
                          pTooltip="Quitar" (click)="removeFromCart(item)"></button>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="8" class="text-center p-3">Agrega productos desde el catálogo.</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>

          <p-popover #commentPopover [style]="{width: '420px'}">
            @if (activeCommentItem) {
              <label class="block font-bold mb-2">Notas — {{ activeCommentItem.sku }}</label>
              <p-editor [(ngModel)]="activeCommentItem.comments" [style]="{height: '180px'}">
                <ng-template pTemplate="header">
                  <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold" type="button"></button>
                    <button class="ql-italic" aria-label="Italic" type="button"></button>
                    <button class="ql-underline" aria-label="Underline" type="button"></button>
                  </span>
                  <span class="ql-formats">
                    <button class="ql-list" value="ordered" aria-label="Ordered List" type="button"></button>
                    <button class="ql-list" value="bullet" aria-label="Unordered List" type="button"></button>
                  </span>
                  <span class="ql-formats">
                    <button class="ql-link" aria-label="Insert Link" type="button"></button>
                  </span>
                  <span class="ql-formats">
                    <button class="ql-clean" aria-label="Remove Styles" type="button"></button>
                  </span>
                </ng-template>
              </p-editor>
            }
          </p-popover>

          <div class="flex justify-content-between pt-4">
            <button pButton label="Cancelar" icon="pi pi-times" severity="secondary" [outlined]="true"
              class="footer-btn" (click)="cancelOrderCreation()"></button>
            <div class="flex gap-2">
              <button pButton label="Atrás" icon="pi pi-arrow-left" severity="secondary" class="footer-btn"
                (click)="goToStep(1)"></button>
              <button pButton label="Siguiente" icon="pi pi-arrow-right" iconPos="right" class="footer-btn"
                (click)="goToStep(3)"></button>
            </div>
          </div>
        </ng-template>
      </p-step-panel>

      <!-- Paso 3: Resumen -->
      <p-step-panel [value]="3">
        <ng-template pTemplate="content">

          <div class="wizard-panel mb-4">
            <h4 class="mt-0"><span class="panel-icon"><i class="pi pi-info-circle"></i></span>Información general</h4>
            <div class="grid">
              <div class="col-12 md:col-6"><strong>Cuenta:</strong> {{ selectedAccountName }}</div>
              <div class="col-12 md:col-6">
                <strong>Tipo de orden:</strong>
                {{ infoForm.value.orderType === 'ENTREGA' ? 'Entrega' : 'Recepción' }}
              </div>
              <div class="col-12 md:col-6">
                <strong>Fecha programada:</strong>
                {{ infoForm.value.scheduledDate | date:'dd/MMM/yyyy h:mm a' }}
              </div>
              <div class="col-12 md:col-6"><strong>Titular:</strong> {{ infoForm.value.titular || '—' }}</div>
              <div class="col-12 md:col-6">
                <strong>Ubicación:</strong>
                {{ infoForm.value.location === 'DOMICILIO' ? 'Domicilio' : 'Bodega' }}
              </div>
              <div class="col-12 md:col-6"><strong>Plataforma:</strong> {{ infoForm.value.platform }}</div>
              @if (infoForm.value.location === 'DOMICILIO') {
                <div class="col-12"><strong>Dirección:</strong> {{ infoForm.value.address }}</div>
              }
              <div class="col-12"><strong>Descripción:</strong> {{ infoForm.value.description || '—' }}</div>
            </div>
          </div>

          <div class="wizard-panel">
            <h4 class="mt-0 flex align-items-center gap-2 flex-wrap">
              <span class="panel-icon"><i class="pi pi-box"></i></span>
              <span>Productos ({{ selectedItems.length }})</span>
              <p-tag [value]="'Total: ' + totalSelectedQuantity + ' artículos'" severity="info"></p-tag>
            </h4>
            <p-table [value]="selectedItems" dataKey="productId" styleClass="p-datatable-sm p-datatable-gridlines">
              <ng-template pTemplate="header">
                <tr>
                  <th>#</th>
                  <th>SKU</th>
                  <th>Descripción</th>
                  <th>Variante</th>
                  <th>Cantidad</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                <tr>
                  <td>{{ rowIndex + 1 }}</td>
                  <td>{{ item.sku }}</td>
                  <td>{{ item.description }}</td>
                  <td>{{ item.variant }}</td>
                  <td>{{ item.quantity }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>

          <div class="flex justify-content-between pt-4">
            <button pButton label="Cancelar" icon="pi pi-times" severity="secondary" [outlined]="true"
              class="footer-btn" (click)="cancelOrderCreation()"></button>
            <div class="flex gap-2">
              <button pButton label="Atrás" icon="pi pi-arrow-left" severity="secondary" class="footer-btn"
                (click)="goToStep(2)"></button>
              <button pButton label="Confirmar" icon="pi pi-check" class="footer-btn" [loading]="submitting"
                (click)="confirmOrder()"></button>
            </div>
          </div>
        </ng-template>
      </p-step-panel>

      <!-- Paso 4: Confirmación -->
      <p-step-panel [value]="4">
        <ng-template pTemplate="content">
          <div class="flex flex-column align-items-center text-center gap-4 py-6">
            <i class="pi pi-check-circle text-8xl text-green-500"></i>
            <h2 class="m-0 text-3xl">Tu orden ORD-{{ createdOrderId }} fue creada exitosamente</h2>
            <p class="text-color-secondary text-lg m-0">
              Cualquier duda o aclaración, contáctanos en
              <a href="mailto:operaciones@bild.com.mx">operaciones&#64;bild.com.mx</a>.
            </p>
            <div class="flex gap-2 mt-3">
              <button pButton label="Crear otra orden" icon="pi pi-plus" severity="secondary" class="footer-btn"
                (click)="createAnotherOrder()"></button>
              <button pButton label="Listo" icon="pi pi-check" class="footer-btn" (click)="goToOrders()"></button>
            </div>
          </div>
        </ng-template>
      </p-step-panel>

    </p-step-panels>
  </p-stepper>
</div>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
